import { render, staticRenderFns } from "./_SupplierTable.vue?vue&type=template&id=7955f5e8"
import script from "./_SupplierTable.vue?vue&type=script&lang=js"
export * from "./_SupplierTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports